import { TranslationKey, useTranslator } from '@Localization';
import { ReactElement } from 'react';
import { IProjectActivity, IProjectActivityUpdateTool } from '../../projectDetailsActivities.models';

export const UpdateToolActivity = ({ values }: IProjectActivity<IProjectActivityUpdateTool>): ReactElement => {
  const { t } = useTranslator();

  const properties: {
    name: TranslationKey;
    original: string;
    current: string;
  }[] = [];

  if (values.originalName !== values.name) {
    properties.push({
      name: 'activity_description_UpdateTool.name',
      original: values.originalName,
      current: values.name,
    });
  }
  if (values.originalColor !== values.color) {
    properties.push({
      name: 'activity_description_UpdateTool.color',
      original: values.originalColor,
      current: values.color,
    });
  }
  if (values.originalSelectorType !== values.selectorType) {
    properties.push({
      name: 'activity_description_UpdateTool.selectorType',
      original: t(values.originalSelectorType),
      current: t(values.selectorType),
    });
  }
  if (values.originalOrder !== values.order) {
    properties.push({
      name: 'activity_description_UpdateTool.order',
      original: values.originalOrder.toString(),
      current: values.order.toString(),
    });
  }

  return (
    <span>
      {t('activity_description_UpdateTool.start')}
      <b>{values.originalName}</b>
      {t('activity_description_UpdateTool.changed')}
      {properties.map((p) => t(p.name)).join(', ')} {t('activity_description_common.from')} <b>{properties.map((p) => p.original).join(', ')}</b>{' '}
      {t('activity_description_common.to')} <b>{properties.map((p) => p.current).join(', ')}</b>.
    </span>
  );
};
